module.exports = __webpack_public_path__ + "img/2.bc0a684f.png";